export default "__VITE_ASSET__4fe95245__"